module.exports = __webpack_public_path__ + "img/logo-white.d48d05db.png";